export const formatPrice = (value: number | undefined): string | number | undefined => {
  if (value && !Number.isInteger(value)) return value.toFixed(2);
  return value;
};
